import type { IRichTextFont } from '../../../components/RichTextField'

export type Tags = 'online' | 'online ao vivo' | 'presencial'

export const tagsLabels: Record<Tags, string> = {
  online: 'Online',
  'online ao vivo': 'Online ao Vivo',
  presencial: 'Presencial'
}

export interface IBannerData {
  id: number
  title?: string
  subtitle?: string
  text?: string
  image?: string | File | null
  image_mobile?: string | File | null
  video_url?: string
  video_url_mobile?: string
  cta_text?: string
  cta_link?: string
  is_active?: boolean | number
  title_color?: string
  subtitle_color?: string
  tag_presencial_color?: string
  tag_online_color?: string
  tag_online_ao_vivo_color?: string
  tag_presencial_text_color?: string
  tag_online_text_color?: string
  tag_online_ao_vivo_text_color?: string
  button_text_color?: string
  gradient_color?: string
  is_gradient_active?: boolean | number
  button_color?: string
  tags?: Tags[]
}

export interface IBannerRequest {
  title?: string
  subtitle?: string
  text?: string
  image?: File | null
  image_mobile?: File | null
  video_url?: string
  video_url_mobile?: string
  cta_text?: string
  cta_link?: string
  is_active?: boolean | number
  title_color?: string
  subtitle_color?: string
  tag_presencial_color?: string
  tag_online_color?: string
  tag_online_ao_vivo_color?: string
  tag_presencial_text_color?: string
  tag_online_text_color?: string
  tag_online_ao_vivo_text_color?: string
  button_text_color?: string
  gradient_color?: string
  is_gradient_active?: boolean | number
  button_color?: string
  tags?: Tags[]
}

export interface IBannerPageCardProps {
  data: IBannerData
  /** Fontes do seletor do editor (`useBannerFonts`), carregadas antes de o card montar. */
  fonts: IRichTextFont[]
  onChange: (data: IBannerData) => void
  errors: Record<keyof IBannerRequest, string[]>
  changePosition: (direction: 'up' | 'down') => void
  openDeleteDialog: () => void
  handleSwitch: (e: React.ChangeEvent<HTMLInputElement>, id: number) => void
  /** `true` enquanto o ativa/desativa daquele banner está no ar (`usePendingRows`). */
  isSwitchSaving: (id: number) => boolean
}
